<template>
    <nav id="bottom-nav" :class="{ 'hide-nav': hideNav, 'is-offline': !isOnline }">
        <div class="top-bar">
            <div class="top-bar-left">
                <ul class="menu app-nav-menu">
                    <li class="menu-item">
                        <button type="button" class="btn-nav-link" @click="navigateTo({ name: 'news' })">
                            <font-awesome-icon :icon="['fal', 'comment-lines']" size="1x" />
                            <span class="badge nav-badge" v-if="newsCount >= 0">{{ newsCount }}</span>
                        </button>
                    </li>
                    <li class="menu-item">
                        <button type="button" class="btn-nav-link" @click="navigateTo({ name: 'bookmarks' })">
                            <font-awesome-icon :icon="['fal', 'heart']" size="1x" />
                            <span class="badge nav-badge" v-if="bookmarksCount >= 0">{{ bookmarksCount }}</span>
                        </button>
                    </li>
                </ul>
            </div>
            <div class="top-bar-center">
                <router-link :to="{ name: 'my-card' }" type="button" class="btn-open-cards">
                    <img src="@/assets/imgs/mycard.png" alt="mycard">
                </router-link>
            </div>
            <div class="top-bar-right">
                 <ul class="menu app-nav-menu">
                    <li class="menu-item">
                        <season-switch icon-size="1x" />
                    </li>
                    <li class="menu-item">
                        <button type="button" class="btn-nav-link" @click="dispatchOffCanvasToggle">
                            <font-awesome-icon :icon="['fal', 'cog']" size="1x" />
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        <div class="offline-status-bar" :class="{ 'offline-status-bar': true, 'show-status': !isOnline}">
            <font-awesome-icon :icon="['fal', 'wifi-slash']" :style="{ marginRight: '.5rem', fontSize: '.75rem' }" />
            {{ $t('offlineInfo') }}
        </div>
    </nav>
</template>

<script>
    import SeasonSwitch from '@/components/SeasonSwitch.vue'

    export default{
        name: 'BottomNavigation',
        components: {
            SeasonSwitch
        },
        props: {
            hideNav: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                isOnline: true
            }
        },
        methods: {
            navigateTo (routeArgs) {
                this.$router.push(routeArgs)
            },
            dispatchOffCanvasToggle () {
                this.$emit('openOffCanvas')
            }
        },
        computed: {
            newsCount () {
                return this.$store.getters.getCurrentNews.length
            },
            bookmarksCount () {
                // console.log('bookmarksCount', this.$store.getters.getCurrentBookmarks);
                return this.$store.getters.getCurrentBookmarks.length
            }
        },
        mounted() {
            this.isOnline = navigator.onLine

            this.$eBus.$on('connectionStateChanged', () => {
                this.isOnline = navigator.onLine
            })
        }
    }
</script>

<style lang="scss" scoped>
    #bottom-nav{
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 15;
        transition: all .2s ease-in-out;
        box-shadow: 0px -1px 2px rgba($black, .10);

        &.is-offline{
            padding-bottom: 1rem;
        }

        // &.hide-nav {
        //     opacity: 0;
        //     visibility: hidden;
        //     z-index: -1;
        // }

        .offline-status-bar{
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            padding: .25rem 0;
            text-align: center;
            font-size: .8rem;
            background-color: get-color(primary);
            color: $white;
            transition: all .15s ease-in-out;

            opacity: 0;
            visibility: hidden;
            transform: translate(0,-100%);

            &.show-status{
                opacity: 1;
                visibility: visible;
                transform: translate(0,0);
            }
        }

        .top-bar{
            @include xy-grid();
            border-top: 1px solid $light-gray;

            .top-bar-left,
            .top-bar-center,
            .top-bar-right{
                @include xy-cell(4);
                display: flex;
                align-items: center;
            }

            .btn-open-cards{
                position: absolute;
                top: 0;
                left: 50%;
                width: rem-calc(80);
                height: rem-calc(80);
                background-color: get-color(secondary);
                border-radius: 50%;
                transform: translate(-50%, -55%);
                cursor: pointer;
                box-shadow: 0px -1px 2px 2px rgba($black, .10);
                z-index: 10;

                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    max-width: rem-calc(55);
                }
            }

            .btn-nav-link {
                position: relative;
                cursor: pointer;
            }

            .nav-badge {
                position: absolute;
                top: 0;
                right: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 1.25rem;
                height: 1.25rem;
                min-width: 0px;
                min-height: 0px;
                transform: translate(65%, -25%);
            }

            .menu{
                &.app-nav-menu{
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    width: 100%;

                    .menu-item{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding: .5rem;
                        font-size: 1.5rem;

                        @include breakpoint(medium) {
                            font-size: 2rem;
                        }
                    }
                }
            }

            @media screen and (max-width: 450px) {
                .top-bar-center{
                    @include xy-cell(12);
                    order: 1;
                    margin-bottom: 1rem;
                }
                .top-bar-left{
                    @include xy-cell(6);
                    order: 2;
                }
                .top-bar-right{
                    @include xy-cell(6);
                    order: 3;
                }
            }
        }
    }
</style>